module.exports = __webpack_public_path__ + "81cfecf2a6a3694da4900e341c681083.png";